<template>
    
  <div class="flex sm:flex-wrap md:flex-no-wrap gap-x-5">
   
    <div class="sm:w-full md:w-4/12 lg:w-3/12">
      <vs-card class="relative p-2">
         <vs-progress class="topper" v-show="busy"
          :height="2" indeterminate color="primary">primary</vs-progress>
        <div class="pb-4">
          <h6 class="font-bold mt-2">Período</h6>

          <a-select
            default-value="0"
            label-in-value
            size="large"
            :value="selectedMounth"
            style="width: 100%;"
            @change="monthChanged">
            <a-select-option v-for="mouth in periods"
              :key="mouth.value" :value="mouth.value"> 
              {{ mouth.desc }} 
             </a-select-option>
          </a-select>
        </div>

        <FiscalFilter :showPayments="false"
          :dates="dates"
          skipRangeValidation
          @filter="refine"/>

      </vs-card>

      <StatisticCard hideChart
                  class="mt-base mb-base"
                  icon-right
                  :statistic="nfces.length"
                  clickable @click="downloadDocuments"
                  statisticTitle="Total de notas">

            <feather-icon icon="DownloadCloudIcon" slot="icon"
              class="p-3 inline-flex rounded-full text-red"
              :style="`background: rgba(255, 0, 0,.5)`"></feather-icon>

      </StatisticCard>
                  
      <StatisticCard hideChart
                  class="mb-base"
                  icon="DollarSignIcon"
                  icon-right
                  isCurrency
                  :statistic="totalValueNfces"
                  statisticTitle="Valor total" />
    </div>
           
    <div class="sm:w-full md:w-8/12 lg:w-9/12">
      
      <vs-card>
        <div class="flex pl-4 mr-1">
          <h4 class="m-2" style="flex: 1"> Valores por CFOPs </h4>
          <DropDownButton label="Exportar xlsx" icon="get_app"
            @click="exportTable(byCfops, cfopsHeader)"
          >
            <vs-dropdown-item @click="exportTable(byCfops, cfopsHeader, 'csv')"> csv </vs-dropdown-item>
            <vs-dropdown-item @click="exportTable(byCfops, cfopsHeader, 'txt')"> txt </vs-dropdown-item>  
          </DropDownButton>
        </div>
        <vs-table :data="byCfops" 
          noDataText="Sem dados para o filtro informado"
          stripe style="width: 100%" class="mt-4">

          <template slot="thead">
            <vs-th sort-key="cfop">CFOP</vs-th>
            <vs-th>Valor em produtos</vs-th>
            <vs-th>Valor movimentado</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                {{ data[indextr].cfop }}
              </vs-td>

              <vs-td>
                {{ data[indextr].totalProducts | currency }}
              </vs-td>

              <vs-td> 
                {{ data[indextr].totalValue | currency }}
              </vs-td>
              
            </vs-tr>

            </template>
        </vs-table>
      </vs-card>

      <vs-card>
        <div class="flex pl-4 mr-1">
          <h4 class="m-2" style="flex: 1"> Notas no período </h4>
          <DropDownButton label="Exportar xlsx" icon="get_app"
            @click="exportTable(nfces, nfceHeader)"
          >
            <vs-dropdown-item @click="exportTable(nfces, nfceHeader, 'csv')"> csv </vs-dropdown-item>
            <vs-dropdown-item @click="exportTable(nfces, nfceHeader, 'txt')"> txt </vs-dropdown-item>  
          </DropDownButton>
        </div>
        <vs-table :data="nfces"
          noDataText="Sem dados para o filtro informado"
          pagination stripe style="width: 100%" class="mt-4">
              <template slot="thead">
                <vs-th v-for="header in nfceHeaderTitles" :key="header.key"
                  :sort-key="header.key">
                  {{ header.title }}
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td>
                    {{ data[indextr].number }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].serie }}
                  </vs-td>
                
                  <vs-td>
                    {{ data[indextr].key }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].emmittedAt | moment('DD/MM/YYYY HH:mm')}}
                  </vs-td>
                  
                  <vs-td>
                    {{ data[indextr].productsValue | currency}}
                  </vs-td>
                  
                  <vs-td>
                    {{ data[indextr].value | currency}}
                  </vs-td>
                  
                </vs-tr>

              </template>
        </vs-table>
      </vs-card>
    </div>

    <a-modal v-model="downloader.processing" :footer="null">
      <div class="vx-row">
        <div class="vx-col w-full">
          Exportando... {{ downloader.processed }} de {{ downloader.total }}
          <a-progress :percent="downloader.percentage" />
        </div>
      </div>
    </a-modal>
   
  </div>
</template>

<script>
  import * as moment from "moment";
  import Bugsnag from '@bugsnag/js';
  import { mapActions, mapState } from 'vuex';
  import FiscalFilter from './FiscalFilter';
  import * as excel from '@/Export2Excel';
  import hash from '../../hash';
  import downloader from './dowloader';
  import DropDownButton from '../../components/DropDownButton';
  import StatisticCard from '../../components/statistics-cards/StatisticCard';

  export default {
    components: {
      FiscalFilter,
      DropDownButton,
      StatisticCard
    },
    data() {
      return {
        orders: [],
        busy: false,
        month: '0',
        selectedMounth: undefined,
        dates: { from: new Date(), to: new Date() },
        cfopsHeader: {
          cfop: { title: 'CFOP', order: 0 },
          totalProducts: { title: 'Valor (R$)', order: 1 },
        },
        nfceHeader: {
          number: { title: 'Número', order: 0 },
          serie: { title: 'Série', order: 1 },
          key: { title: 'Chave de acesso', order: 3 },
          emmittedAt: { title: 'Data', order: 4 },
          productsValue: { title: 'Valor em Produtos', order: 5 },
          value: { title: 'Total da Nota', order: 6 },
        },
        filters: { date: { from: new Date(), to: new Date() } },
        downloader: {
          processing: false,
          total: 0,
          processed: 0,
          percentage: 0
        }
      }
    },
    computed: {
      aggragation () {
        return this.reports.reduce((prev, curr) => {
            Object.keys(curr.totalByCfop).forEach(key => {
              if (!prev.totals[key])
                prev.totals[key] = { products: 0, withDiscount: 0 };
              prev.totals[key].products = (curr.totalByCfop[key] && curr.totalByCfop[key].products || 0) + (prev.totals[key].products || 0);
              prev.totals[key].withDiscount = (curr.totalByCfop[key] && curr.totalByCfop[key].withDiscount || 0) + (prev.totals[key].withDiscount || 0);
            });
            return { totals: prev.totals, nfces: { ...prev.nfces, ...curr.nfces } };
          },
          { totals: {}, nfces: {} }
        );
      },
      byCfops () {
        return Object.entries(this.aggragation.totals).map(([key, value]) => {
          return { cfop: key, totalProducts: value.products, totalValue: value.withDiscount }
        })
      },
      nfces () {
        return Object.values(this.aggragation.nfces);
      },
      nfceHeaderTitles () {
        return Object.entries(this.nfceHeader)
          .map(([key, value]) => ({ key, title: value.title }));
      },
      cfopsHeaderTitles () {
        return Object.values(this.cfopsHeader)
          .map(h => h.title);
      },
      periods () {
        const interval = [];
        for (let i = 0; i < 6; i++) {
          let month = moment().add(-i, 'month');
          month.locale('pt-BR');
          interval.push({ value: month.format('MM/YYYY'), desc: `${month.format('MMMM')} / ${month.format('YYYY')}` })
        }
        return interval;
      },
      totalValueNfces () {
        return this.reports.reduce((prev, curr) => prev + curr.totals.withDiscount, 0);
      },
      ...mapState('fiscalReports', ['reports'])
    },
    methods: {
      async refine (filters) {
        this.busy = true;
        try {
          // Deselects mounth when date itself is changed
          this.selectedMounth = hash(this.dates) === hash(filters.date) ? this.selectedMounth : undefined;
          await this.fetchReportsInPeriod(filters);
        } catch (err) {
          this.setError(err);
        }
        this.busy = false;
      },
      exportTable (data, header, format = 'xlsx') {
        excel.export_json_to_excel({
          header: Object.values(header).map(h => h.title),
          data: data.map(val => Object.keys(val)
            .filter(key => header[key])
            .sort((a, b) => header[a].order - header[b].order)
            .map(key => val[key])),
          filename: moment().format('DD-MM-YYYY HH:mm:ss'),
          autoWidth: true,
          bookType: format
        })
      },
      monthChanged (opts) {
        this.selectedMounth = opts;
        const dt = moment(opts.key, 'MM/YYYY');
        const from = dt.startOf('month').toDate();
        const to = dt.endOf('month').toDate();
        this.filters.date.from = from;
        this.filters.date.to = to;
        this.dates.from = from;
        this.dates.to = to;
      },
      async downloadDocuments () {
        if (!this.nfces.length) {
          this.$message.error('Não há notas no filtro configurado', 4);
          return;
        }
        try {
          this.downloader.processed = 0;
          this.downloader.percentage = 0;
          this.downloader.processing = true;
          this.downloader.total = this.nfces.length;
          const documents = this.nfces.map(doc => ({ key: doc.key, date: doc.emmittedAt }));
          let withError = 0;
          let companyId = this.$store.getters.getCompanyID;
          const cb = (success) => {
            if (success) {
              this.downloader.processed++;
              this.downloader.percentage = Math.ceil((this.downloader.processed * 100) / this.downloader.total);
            } else
              withError++;
          }
          await downloader(companyId, documents, cb);
          if (withError)
            this.setError(new Error('Erro ao baixar notas'), `Ocorreu um problema ao baixar ${withError} notas`);
        } catch (err) {
          this.setError(err, 'Ocorrou algum problema grave.');
        }
        this.downloader.processing = false;
      },
      setError (err, title) {
        Bugsnag.notify(err);
        console.log(err);
        this.$error({
          zIndex : 999999,
          title: title || 'Erro ao enviar nota(s)',
          content: err.message
        });
      },
      ...mapActions('fiscalReports', ['fetchReportsInPeriod'])
    },
    mounted () {
      moment.locale('pt-BR');
    }
  }
</script>

<style lang="scss" scoped>

#algolia-content-container {
    .vs-sidebar {
      position: relative;
      float: left;
    }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

.topper {
    position: absolute;
    top: 0;
    left: 0;
}
</style>